var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card",attrs:{"tile":"","width":"248"}},[_c('MenuList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }